import { isObjectLike, isNil, isEmpty } from 'lodash'

function isBlank(val) {
  if (isObjectLike(val)) return isEmpty(val)

  return isNil(val) || val === ''
}

export default isBlank
